import { render, staticRenderFns } from "./aftertraining.vue?vue&type=template&id=35d2eeba&scoped=true&"
import script from "./aftertraining.vue?vue&type=script&lang=js&"
export * from "./aftertraining.vue?vue&type=script&lang=js&"
import style0 from "./aftertraining.vue?vue&type=style&index=0&id=35d2eeba&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35d2eeba",
  null
  
)

export default component.exports